import DuvalVisualization from './DuvalVisualization';
import './DuvalVisualization.scss';

export { schema, uiSchema } from '../schemas/DuvalVisualizationSchema';
export default DuvalVisualization;
